import { render, staticRenderFns } from "./colorPicker.vue?vue&type=template&id=b47a6696&scoped=true&lang=pug&"
import script from "./colorPicker.vue?vue&type=script&lang=js&"
export * from "./colorPicker.vue?vue&type=script&lang=js&"
import style0 from "./colorPicker.vue?vue&type=style&index=0&id=b47a6696&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47a6696",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b47a6696', component.options)
    } else {
      api.reload('b47a6696', component.options)
    }
    module.hot.accept("./colorPicker.vue?vue&type=template&id=b47a6696&scoped=true&lang=pug&", function () {
      api.rerender('b47a6696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/others/colorPicker.vue"
export default component.exports